import { gql } from "@apollo/client";

export const GetEmployeeRoleNames = gql`
  query GetEmployeeRoleNames {
    employeeRoleMany {
      id
      name
    }
  }
`;

export const GetEmployeeRolePage = gql`
  query GetEmployeeRolePage($pagination: PaginationInput!) {
    employeeRolePage(pagination: $pagination) {
      items {
        id
        name
        seedId
      }
      totalRows
    }
  }
`;

export const GetEmployeeRole = gql`
  query GetEmployeeRole($id: String!) {
    employeeRoleOne(id: $id) {
      id
      name
      description
      orgRoles
      orgPolicies
      orgAgreements
      orgPackages
      orgLocations
      orgService
      orgDiscounts
      orgSettings
      locPolicies
      locAgreements
      locPackages
      locServices
      locDiscounts
      locSettings
      locRooms
      locEmployees
      locProducts
      locRequests
      locTimeclock
      locDashboard
      locReports
      clients
      calendar
      catalog
      checkInQueue
      personalTimeClock
      employeeStations
    }
  }
`;

export const GetEmployeeRoleNamesPossible = gql`
  query GetEmployeeRoleNamesPossible {
    employeeRolesPossible {
      id
      name
    }
  }
`;
